<template>
  <base-sidebar
    :model-value="isOpen"
    fixed
    temporary
    width="400"
    class="pa-0"
    v-bind="$attrs"
    @update:model-value="setOpen"
  >
    <div
      class="sidebar-viewer-header d-inline-flex"
      :class="{ 'sidebar-viewer-header--with-avatar': picture || defaultPicture }"
    >
      <base-picture-avatar
        v-if="picture || defaultPicture"
        :src="(picture) ? picture : ''"
        :src-default="defaultPicture"
        class="my-5 ml-5 mr-2"
        width="50"
        height="50"
      ></base-picture-avatar>

      <div class="sidebar-viewer-header-text">
        <v-card-title
          class="text-h6 sidebar-viewer-title"
          style="word-break: normal;"
        >{{ title }}</v-card-title>

        <v-card-subtitle
          v-if="subtitle"
          class="text-subtitle-1 sidebar-viewer-subtitle"
        >{{ subtitle }}</v-card-subtitle>
      </div>
    </div>

    <v-divider></v-divider>

    <v-expansion-panels
      v-model="panels"
      multiple
      rounded="0"
    >
      <slot />
    </v-expansion-panels>

    <v-card-actions
      class="pa-5"
    >
      <base-sidebar-btn
        v-if="view"
        :to="view"
        :label="viewLabel"
        :icon="viewIcon"
        :btn-class="!$store.state.isDarkMode ? 'mr-4 blue' : 'mr-4 blue-darken-3'"
        icon-color="white"
      ></base-sidebar-btn>
      <slot name="actions" />
      <base-sidebar-btn
        @click="setOpen(false)"
        icon="mdi-close"
        label="Close"
        btn-class="background"
        icon-color="grey"
      ></base-sidebar-btn>
    </v-card-actions>
  </base-sidebar>
</template>

<script>
export default {
  name: 'BaseSidebarViewer',

  inheritAttrs: false,

  props: {
    modelValue: {},
    value: {},
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    picture: {
      type: String,
      default: '',
    },
    defaultPicture: {
      type: String,
      default: '',
    },
    view: {
      type: String,
      default: null,
    },
    viewLabel: {
      type: String,
      default: 'View details',
    },
    viewIcon: {
      type: String,
      default: 'mdi-open-in-new',
    },
  },

  emits: ['update:modelValue', 'input'],

  data: () => ({
    panels: [
      0,
    ],
  }),

  computed: {
    isOpen() {
      return !!(this.modelValue ?? this.value);
    },
  },

  methods: {
    setOpen(open) {
      this.$emit('update:modelValue', open);
      this.$emit('input', open);
    },
  },
};
</script>

<style scoped>
.sidebar-viewer-header {
  width: 100%;
  align-items: flex-start;
}

.sidebar-viewer-header-text {
  flex: 1 1 auto;
  min-width: 0;
}

/* V2 v-card-title/subtitle default padding; V3 standalone titles render tighter */
.sidebar-viewer-header:not(.sidebar-viewer-header--with-avatar) .sidebar-viewer-title {
  padding: 16px 16px 16px 20px;
}

.sidebar-viewer-header--with-avatar .sidebar-viewer-title {
  padding: 20px 16px 4px 0;
}

.sidebar-viewer-header--with-avatar .sidebar-viewer-subtitle {
  padding: 0 16px 20px 0;
}

.sidebar-viewer-header:not(.sidebar-viewer-header--with-avatar) .sidebar-viewer-subtitle {
  padding: 0 16px 16px 20px;
}
</style>
